<template>
  <div class="tenant_info_area" id="tenant_info">
    <div class="edit_area_half">
      <valueLabelSection
        :titleLabel="companyIdLabel"
        :valueLabel="corporation.companyId"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="companyNameLabel"
        :valueLabel="corporation.companyName"
      ></valueLabelSection>
      <!-- <valueLabelSection :titleLabel='gpsEnableFlagLabel'
                     :valueLabel='gpsEnableFlag'></valueLabelSection> -->
    </div>
    <div class="edit_area_half">
      <valueLabelSection
        :titleLabel="adminUserIdLabel"
        :valueLabel="corporation.adminUsers[0].adminUserId"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="adminUserNameLabel"
        :valueLabel="corporation.adminUsers[0].adminUserName"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="mailAddressLabel"
        :valueLabel="corporation.adminUsers[0].mailAddress"
      ></valueLabelSection>
      <valueLabelSection
        v-if="showPasswordLabel"
        :titleLabel="passwordLabel"
        :valueLabel="corporation.adminUsers[0].password"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="mailTargetFlagLabel"
        :valueLabel="mailTargetFlag"
      ></valueLabelSection>
    </div>
  </div>
</template>

<script>
import valueLabelSection from './valueLabelSection.vue'

export default {
  props: {
    showPasswordLabel: Boolean
  },
  data() {
    return {
      companyIdLabel: 'テナントID',
      companyNameLabel: 'テナント名',
      gpsEnableFlagLabel: 'GPS情報機能の使用有無',
      adminUserIdLabel: '管理者ID',
      adminUserNameLabel: '管理者名',
      mailAddressLabel: 'メールアドレス',
      passwordLabel: '管理者パスワード',
      mailTargetFlagLabel: '警告メール送信の使用有無'
    }
  },
  components: {
    valueLabelSection
  },
  computed: {
    corporation() {
      return this.$store.state.corporations.corporation
    },
    gpsEnableFlag() {
      return this.corporation.gpsEnableFlag.toString() === 'true' ? 'ON' : 'OFF'
    },
    mailTargetFlag() {
      return this.corporation.mailTargetFlag.toString() === 'true'
        ? 'ON'
        : 'OFF'
    }
  }
}
</script>

<style scoped>
.detail_content {
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationComponents/tenantInfo.vue